import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import edit from './edit';
import save from './save';

registerBlockType('ipm/collapseblock', {
	apiVersion: 2,
	title: __('Collapse Block'),
	description: __('Collapses inner elements to a simple button, which extends on click.'),
	category: 'design',
	icon: 'ipm',
	keywords: [__('collapseblock, mini, maxi, roll, rollout, shrink, toggle')],
	attributes: {
		title: {
			type: 'string',
			default: undefined,
		},
		blockId: {
			type: 'string',
		},
	},
	example: {
		attributes: {
			title: 'Collapse title',
			blockId: 'example-id',
		},
		viewportWidth: 400,
	},
	supports: {
		anchor: false,
		align: [],
		className: true,
		customClassName: false,
		html: false,
		reusable: true,
	},
	edit,
	save,
});
